export const AMAP_KEY: string = "dc6e3523139c5be6cfdd7c5b297833bf";
export const AMAP_VERSION: string = "2.0";

export const isDebug = false;
export const themeArray = ['light', 'dark'];
